import React from 'react';
import { Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ConfirmationModal.module.scss';
import clsx from 'clsx';
import { commonVaribles } from 'src/constants/constVariables';
import { fieldHeadings } from 'src/constants/constant';
import { Button } from 'src/components/Atoms';

export const ConfirmationModal = ({
	open,
	title,
	handleClose,
	onConfirm,
	missingFields,
}) => {
	return (
		<Modal open={open} onClose={handleClose} className={styles.modalstyle}>
			<div className={styles.containerstyle}>
				<div className={styles['title-div']}>
					<h1 className={styles.titleStyle}>{title}</h1>
					<div className={styles.closeIconStyle}>
						<CloseIcon onClick={handleClose} />
					</div>
				</div>
				<div style={{ width: '100%', height: 1, backgroundColor: '#6F6F6F' }} />
				<div className={styles.mainbody}>
					<div className={styles.confirmationNote}>
						<div>The Following images are missing in the form:</div>
						<div className={styles.missingImages}>
							{missingFields.map((field) => (
								<li key={field}>{fieldHeadings[field] || field}</li>
							))}
						</div>
					</div>
					<div className={styles.bottomRow}>
						<Button
							variant="secondary"
							className={clsx(styles.cancelBt, 'regularFont')}
							onClick={handleClose}
						>
							{commonVaribles.cancel}
						</Button>
						<span>
							<Button
								variant="primary"
								onClick={() => {
									onConfirm();
								}}
								className={clsx(styles.uploadBt, 'regularFont')}
							>
								{commonVaribles.submit_anyways}
							</Button>
						</span>
					</div>
					{/* </div> */}
				</div>
			</div>
		</Modal>
	);
};
